import { ChapterLabel } from "./ChapterLabel";
import { Reveal } from "./Reveal";

export const Problem = () => (
  <section id="problem" className="py-24 sm:py-32" data-testid="problem-section">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <ChapterLabel text="Chapter 02 // The Diagnosis" />
      </Reveal>
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
        <Reveal className="lg:col-span-5">
          <h2 className="font-display text-3xl sm:text-5xl font-bold tracking-tight leading-tight text-white">
            Most Local Businesses Are Flying Blind
          </h2>
        </Reveal>
        <Reveal delay={0.15} className="lg:col-span-6 lg:col-start-7">
          <p className="text-lg sm:text-xl text-slate-300 leading-relaxed border-l-2 border-white/20 pl-6 sm:pl-8">
            Your website might be losing visitors. Your Google listing might be
            invisible. Your leads might be going cold before you even call them
            back. Most business owners have no idea — because nobody's checking.
          </p>
        </Reveal>
      </div>
    </div>
  </section>
);
